export class AdminRole {
  GroupName: string;
  Description: string;

  isMxAdmin(): boolean {
    return (
      this.GroupName === 'access-mxadmin' ||
      this.GroupName === 'app-access-mxadmin'
    );
  }

  isParticipantAdmin(): boolean {
    return (
      this.GroupName === 'access-participantadmin' ||
      this.GroupName === 'app-access-participantadmin' ||
      this.GroupName === 'notify-participantadmin' ||
      this.GroupName === 'app-notify-participantadmin'
    );
  }
}
